// extracted by mini-css-extract-plugin
export default {"textPart":"textpart_textPart__DO33u"};